import constants from "../constants";
import successHandle from "../../utils/successHandle";
import errorHandle from "../../utils/errorHandle";

const { GET_PAYOUTS, GET_PAYOUTS_SUCCESS, GET_PAYOUTS_ERROR, DELETE_PAYOUT, DELETE_PAYOUT_SUCCESS, DELETE_PAYOUT_ERROR, APPROVE_PAYOUT, APPROVE_PAYOUT_SUCCESS, APPROVE_PAYOUT_ERROR, REJECT_PAYOUT, REJECT_PAYOUT_SUCCESS, REJECT_PAYOUT_ERROR } = constants;
const initialState = { payouts: [], completedPayouts: [], pendingPayouts: [] }

export const payoutsReducer = (state = initialState, action) => {
  const { type, payouts, message, error } = action;
  switch (type) {
    case GET_PAYOUTS:
    case DELETE_PAYOUT:
    case APPROVE_PAYOUT:
    case REJECT_PAYOUT:
      return { ...state, loading: true, error: '', message: '' }

    case GET_PAYOUTS_SUCCESS:
      return { ...state, loading: false, payouts}
    case DELETE_PAYOUT_SUCCESS:
    case APPROVE_PAYOUT_SUCCESS:
    case REJECT_PAYOUT_SUCCESS:
      return { ...state, loading: false, message: successHandle(message) }

    case GET_PAYOUTS_ERROR:
    case DELETE_PAYOUT_ERROR:
    case APPROVE_PAYOUT_ERROR:
    case REJECT_PAYOUT_ERROR:
      return { ...state, loading: false, error: errorHandle(error) }

    default:
      return state
  }
}
